<template>
  <v-data-table ref="dataTable"
                :items="schaeden"
                :items-per-page="10"
                :headers="headers"
                :search="search"
                :sort-by="'Meldedatum'"
                :sort-desc="true"
                :footer-props="footerProps"
                locale="de-DE"
                no-data-text="Keine Schäden vorhanden"
                no-results-text="Keine Schäden gefunden"
                must-sort
                class="schaden--table data--table no--hover">

    <!--- data rows ----------------------------------------------------------------------------->
    <template v-slot:item="{item}">
      <tr>
      <td>
        <v-tooltip top nudge-bottom="8">
          <template v-slot:activator="{on}">
            <v-icon :color="getColor(item.Deckungszusage)"
                    v-on="on">
              {{ getIcon(item.Deckungszusage) }}
            </v-icon>
          </template>
          <span class="caption">{{ item.Deckungszusage }}</span>
        </v-tooltip>
      </td>
      <td>{{ item.erledigt | erledigtAsStatus }}</td>
      <td>{{ item.Schadennummer }}</td>
      <td>{{ item.Kosten | currency }}</td>
      <td>{{ item.Meldedatum }}</td>
      <td>{{ item.Ereignisdatum }}</td>
      <td>{{ item.VertragsTyp | leistungsart }}</td>
      <!--<td @click.stop="$emit('show-contract', props.item.Vertragsnummer )">-->
      <!--<v-tooltip top>-->
      <!--<v-icon slot="activator">insert_drive_file-->
      <!--</v-icon>-->
      <!--<span>Vertrag in Tab öffnen</span>-->
      <!--</v-tooltip>-->
      <!--</td>-->

      </tr>
    </template>

  </v-data-table>
</template>
<script>
import FiltersMixin from '@/components/kundenverwaltung/FiltersMixin';
import { FOOTER_PROPS } from './tableConfig';

export default {
  name: "VertragsSchaedenTable",
  mixins: [FiltersMixin],
  props: {
    schaeden: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      footerProps: FOOTER_PROPS,
      headers: [
        { text: 'Deckungszusage', value: 'Deckungszusage', sortable: true },
        { text: 'Status', value: 'erledigt', sortable: true },
        { text: 'Schadennummer', value: 'Schadennummer', sortable: true },
        { text: 'Bisherige Leistungen', value: 'Kosten', sortable: true },
        { text: 'Meldedatum', value: 'MeldedatumSortable', sortable: true, class: Number },
        { text: 'Ereignisdatum', value: 'EreignisdatumSortable', sortable: true, class: Number },
        { text: 'Leistungsart', value: 'VertragsTyp', sortable: true },
      ]
    };
  },
  methods: {
    getColor(value) {
      switch (value) {
        case 'Ja':
        case 'erteilt':
          return 'success';
        case 'Nein':
        case 'abgelehnt':
          return 'error';
        case 'offen':
          return 'inherit';
        default:
          return '';
      }
    },
    getIcon(value) {
      switch (value) {
        case 'Ja':
        case 'erteilt':
          return 'check';
        case 'Nein':
        case 'abgelehnt':
          return 'clear';
        case 'offen':
          return 'hourglass_empty';
        default:
          return '';
      }
    }
  }
};
</script>
<style>

</style>
